export var HEADER_ACCEPT_CURRENCY = "X-ACCEPT-CURRENCY";
